const HeroSection = {
  hero_title_part1: "Лёгкий способ",
  hero_title_part2: "отправить посылку",
  hero_text: "Отправляйте груз не выходя из дома",
  hero_btn: "Все компании",
  hero_card_title: "Выберите маршрут доставки",
  hero_card_section_title1: "Откуда",
  hero_card_section_text1: "Откуда будет отправлен груз?",
  hero_card_section_title2: "Куда",
  hero_card_section_text2: "Куда будет отправлен груз?",
  hero_card_section_title3: "Вес груза",
  hero_card_section_text3: "Введите средний вес груза",
  hero_card_btn: "Показать результаты",
  hero_presentation_title1: "Наши преимущества",
  hero_presentation_text1: "Самый продвинутый сервис доставки",
  hero_presentation_content1_title1: "Заберут с адреса",
  hero_presentation_content1_text1:
    "Вам больше не нужно выходить из дома, чтобы отправить груз",
  hero_presentation_content1_title2: "Доступная и безопасная доставка",
  hero_presentation_content1_text2: "Отправляйте посылки от $ 1 *",
  hero_presentation_content1_title3: "Отслеживание грузов",
  hero_presentation_content1_text3:
    "Вы можете отслеживать, где находится ваш груз",

  hero_presentation_title2: "Как отправить груз?",
  hero_presentation_text2: "Детали отправки",
  hero_presentation_content2_title1: "Упаковка",
  hero_presentation_content2_text1:
    "Измерьте свой груз для отправки и выберите грузовую компанию",
  hero_presentation_content2_title2: "Подготовка",
  hero_presentation_content2_text2:
    "Курьер принимает ваш груз по вашему адресу в тот же день, упаковывает его и готовит к отправке.",
  hero_presentation_content2_title3: "Отправка и отслеживание",
  hero_presentation_content2_text3:
    "Когда ваш груз находится в пути, вы можете отследить его по предоставленному трек номеру.",
};

const HomeFAQ = {
  home_faq_title: "Часто задаваемые вопросы",
  home_faq_tab1: "Общее",
  home_faq_tab2: "Поддержка",
  home_faq_tab3: "Об отправке",
  home_faq_tab4: "Sorular",
  home_faq_tab1_question1: "Как отправить груз?",
  home_faq_tab1_question2: "Как я могу отследить свой груз?",
  home_faq_tab1_question3: "За сколько дней будет доставлено?",
  home_faq_tab1_question4: "На что следует обратить внимание?",
  home_faq_tab1_question5: "Как производится оплата?",
};

const Blog = {
  blog_title: "Блог",
  blog_text: "Статьи ",
  blog_card_delivery: "Отправка",
  blog_card_coupon: "Купон",
  blog_card_discount: "Скидка",
};

const FormControls = {
  smart_sorting: "Умная сортировка",
  by_rating: "По рейтингу",
  by_price: "По цене",
  by_delivery_speed: "По скорости доставки",
  oldest_comments: "Самые старые отзывы",
  newest_comments: "Последние отзывы",
  all_comments: "Все отзывы",
};

const ProductCard = {
  day: "Дней",
  fast_delivery: "Быстрая доставка",
  highlights: "Рекоменуемые",
  new_companies: "Новые компании",
  product_card_delivery: "Доставка",
  product_card_kg_price: "Цена за кг",
  product_card_minimum: "Минимальный вес",
};

export const Header = {
  header_search: "Искать",
  header_btn: "Отследить груз",
  current_language: "русский",
};

export const Footer = {
  footer_copyright: "Все права защищены © 2021",
  footer_link_title1: "Фирма",
  footer_link_title2: "Общее",
  footer_link_about: "О нас",
  footer_link_services: "Услуги",
  footer_link_blog: "Блог",
  footer_link_policy: "Политика конфиденциальности",
  footer_link_companies: "Компании",
  footer_link_faq: "Часто задаваемые вопросы",
  footer_subscription_title: "Присоединяйтесь к нам",
  footer_subscription_input: "Напишите свою почту",
  footer_coded_by_me: "закодировано Bilkan Konus"
};

export const SiteNav = {
  adressess: "Мои адреса",
  cargos: "Мои отправки",
  settings: "Настройки",
  track_cargo: "Отследить отправку",
  logout: "Выйти",
  search: "Поиск",
  account: "Профиль",
};

const Info = {
  total_founded: "Найдено",
  cargo_companies: "Компании",
  company: "компаний",
  comment: "Отзывы",
  membership_date: "Дата регистрации",
  cargo_price: "Стоимость доставки",
  starting_price: "",
  about: "hakkında",
  minimum_shipment_abbreviated: "Минимальный вес",
  tooltip_price_may_vary:
    "В зависимости от отправляемого товара может быть разница в цене.",
};

const Comment = {
  company_response: "Ответ Компании",
  comments_loading: "Загрузка",
  add_comment: "Добавить отзыв",
  comment_question: "Вы получали услуги от этой компании? Напишите свое мнение",
  share_your_opinion: "Поделитесь своим мнением",
  share: "Поделиться",
};

const Actions = {
  call_courier: "Вызвать курьера",
  report_company: "Сообщить о компании",
  accept_and_call_courier: "Вызвать курьера",
  go_to_homepage: " Вернуться на главную ",
  action_track_cargo: "Отследить груз",
  action_update_info: "Обновить данные",
  action_cancel: "Отмена",
  action_add_new_address: "Добавить новый адрес",
  action_change: "Изменить",
  action_change_password: "Изменить пароль",
  action_apply: "Применить",
  action_save_address: "Сохранить адрес",
  action_show_results: "Показать результаты",
  action_comment: "Написать отзыв",
  action_go_to_profile: "В профиль",
};

const Paths = {
  home_page: "Главная страница",
  all_companies: "Все компании",
  path_call_courier: "Вызов курьера",
};

const Form = {
  form_calling_courier_and_prica_calculator: "Вызов курьера",
  form_shipper: "Отправитель",
  form_name_surname: "Имя Фамилия",
  form_tel: "Номер телефона",
  form_shipping_address: "Адрес отправки груза",
  form_address_details: "Детальный адрес",
  form_recipient: "Получатель",
  form_warn_empty: "Это поле не может быть пустым",
  form_delivery_address: "Адрес доставки",
  form_what_to_ship: "Что хотите отправить?",
  form_what_to_ship_desc:
    "В зависимости от отправляемого товара может быть разница в цене.",
  form_cargo_weight: "Вес отправки",
  form_box_weight: "Вес посылки",
  form_cargo_receival_date: "Дата получения вашего груза",
  form_date_select_today: "Сегодня",
  form_date_select_tomorrow: "Завтра",
  form_date_custom: "Выбрать дату",
  form_note: "Комментарий",
  form_note_optional: "Необязательно",
  form_privacy_policy: "Я прочитал и принимаю условия",
  form_country: "Город",
  form_district: "Район",
  form_error: "Ошибка",
  form_country_land: "Страна",
  form_do_you_have_coupon: "У вас есть купон?",
  form_enter_coupon_code: "Введите код купона",
};

const TotalCard = {
  total_card_title: "Общее",
  total_card_shipper: "Отправитель",
  total_card_recipient: "Получатель",
  total_card_cargo_route: "Маршрут посылки",
  total_shipment_weight: "Вес посылки",
  total_price_title: "Цены",
  total_cargo_price: "Стоимость доставки",
  total_service_price: "Плата за обслуживание",
  total_free: "Бесплатно",
  total_sum: "Общая сумма",
  total_coupon_discount: "Скидка по купону",
};

const Modal = {
  member_login: "Авторизация",
  modal_new_membership: "Новая  регистрация",
  password_proccess: "Восстановление пароля",
  modal_tel: "Номер телефона",
  forgot_password: "Забыл пароль",
  login: "Войти",
  password: "Пароль",
  login_via_social: "Войти с помощью",
  no_account_question: "У вас нету аккаунта?",
  have_account_question: "У вас есть аккаунт?",
  modal_sign_up: "Зарегистрироваться",
  remember_me: "Запомнить меня",
  password_again: "Повторите пароль",
  renew_password: "Обновить пароль",
  sms_verification: "SMS подтверждение",
  accept_and_continue: "Подтвердить",
  send_code_again: "Отправить код еще раз",
  enter_4_digit_number: "Введите 4-значный код",
  modal_register: "Зарегистрироваться",
  modal_enter_tel_text:
    "Введите свой номер телефона, который вы использовали при регистрации",
  modal_cargo_track: "Отследить посылку",
  modal_enter_track_number: "Введите трек номер",
  track_no: "Трек номер",
};

const InfoPages = {
  info_thanks: "Спасибо!",
  info_no_order_created: "заявка была создана.",
  info_shipping_process: "Процесс доставки можете отследить",
  info_profile: "В профиле",
  info_from_page_follow: "",
  info_track_number: "Трек номер",
};

const ProfilePage = {
  profile_notifications: "Уведомления",
  profile_enter_track_number: "Введите трек номер",
  profile_cargo_status_title: "Статус доставки",
  profile_cargo_situation_onway: "Ваша посылка в пути",
  profile_cargo_situation_delivered: "Доставлено",
  profile_track_no: "Трек номер",
  profile_cargo_from: "Место отправки",
  profile_cargo_to: "Место доставки",
  profile_cargo_date: "Дата отправки",
  profile_price: "Цена",
  profile_all_cargos: "Все посылки",
  profile_on_the_way: "В пути",
  profile_completed: "Доставленные",
  profile_all: "Все",
  profile_cargo_id: "ID посылки",
};

const Settings = {
  settings_support_text: "Чтобы изменить почту  напишите нам.",
  settings_title: "Настройки",
  settings_write_message: "Написать",
  settings_current_password: "Текущий пароль",
  settings_new_password: "Новый пароль",
  settings_new_password_again: "Повторите новый пароль",
};

const MyAdresses = {
  my_addresses_title: "Мои адреса",
  address: "Адрес",
};

const AddAddress = {
  add_address_name: 'Описание адреса (например, "Дом", "Офис")',
  add_address_city: "Город",
  add_address_district: "Район",
  add_address_details: "Адрес",
};

const NotFound = {
  not_found_title: "Страница не найдено",
  not_found_text:
    "Возможно, страница, которую вы ищете, была удалена, или адрес указан неверный.",
};

const CargoTrack = {
  cargo_track_title: "Движение груза",
  cargo_track_cargo_accepted: "Посылка принята",
  cargo_track_shipped: "Отправлено в страну назначения",
  cargo_track_arrived: "Доставлено в страну назначения",
  cargo_track_at_branch: "Ваша посылка в депо",
  cargo_track_out_for_distribution: "Доставляется",
  cargo_track_delivered: "Доставлено",
  cargo_track_last_update: "Последнее изменение",
  cargo_track_no: "Трек номер посылки",
  cargo_track_tel: "Номер телефона",
  cargo_track_sum: "Общая сумма",
};

const FAQ = {
  faq_search_title: "Поиск по вопросам",
  faq_search_placeholder: "Поиск вопросов",
  faq_search_text:
    "Вы можете быстрее прийти к решению, поискав по заданным вопросам. ",
  faq_title: "Часто задаваемые вопросы",
  faq_text_part1: "Если вы не можете найти ответ, который ищете",
  faq_support_link: "Можете написать",
  faq_text_part2: "в поддержку",
  faq_tab1: "Общее",
  faq_tab2: "Про посылку",
  faq_tab3: "Вопросы",
};

const CompanyCard = {
  company_card_free_packaging: "Бесплатная упаковка",
};

const Extra = {
  blog_similar_blogs: "Похожие блоги",
};

const Toast = {
  toast_success_title: "Успешно",
  toast_error_title: "Ошибка",
  toast_warn_title: "Внимание",
  toast_info_title: "Уведомление",
  toast_success_text: "Операция прошла успешно.",
  toast_error_text: "Что-то пошло не так.",
  toast_warn_text: "Текст уведомления",
  toast_info_text: "Текст уведомления",
}

export const Shared = {
  ...Footer,
  ...SiteNav,
  ...FormControls,
  ...ProductCard,
  ...Info,
  ...Paths,
  ...Comment,
  ...Actions,
  ...TotalCard,
  ...Form,
  ...Modal,
  ...InfoPages,
  ...ProfilePage,
  ...Settings,
  ...MyAdresses,
  ...AddAddress,
  ...NotFound,
  ...CargoTrack,
  ...FAQ,
  ...CompanyCard,
  ...Extra,
  ...Toast
};

export const HomePage = {
  ...HeroSection,
  ...HomeFAQ,
  ...Blog,
};
